export async function writeClipboardText(value: string) {
  if (!globalThis.navigator?.clipboard?.writeText)
    throw new Error("Clipboard API is unavailable");
  await globalThis.navigator.clipboard.writeText(value);
}
